<template>
  <!-- 绑定角色 -->
  <PopUp v-if="currentPop === 'Bind'">
    <PopBind></PopBind>
  </PopUp>

  <!-- 规则 -->
  <PopUp v-show="currentPop === 'Rule'">
    <PopRule></PopRule>
  </PopUp>

  <!-- 开始扭蛋 -->
  <CapsuleToys v-show="currentPop === 'CapsuleToys'" @lotteryDate="lotteryDate"></CapsuleToys>

  <!-- 扭蛋结果 -->
  <PopUp v-show="currentPop === 'CapsuleToyResult'">
    <CapsuleToyResult :iconList="iconList" :firstIconList="firstIconList"></CapsuleToyResult>
  </PopUp>

  <!-- 扭蛋结果（已全部解锁） -->
  <PopUp v-show="currentPop === 'CapsuleToyNOResult'">
    <CapsuleToyNOResult></CapsuleToyNOResult>
  </PopUp>

  <!-- 分享 -->
  <PopUp v-show="currentPop === 'Share'">
    <Share></Share>
  </PopUp>

  <!-- 扭蛋次数用尽 -->
  <PopUp v-show="currentPop === 'CapsuleToyNOTicket'">
    <CapsuleToyNOTicket></CapsuleToyNOTicket>
  </PopUp>

  <!-- 查看头像 -->
  <PopUp v-show="currentPop === 'HeadDetails'">
    <HeadDetails></HeadDetails>
  </PopUp>

</template>

<script>
import { mapState } from 'vuex'
import PopUp from './childComps/PopUp.vue'
import PopBind from './childComps/Bind.vue'
import PopRule from './childComps/Rule.vue'
import CapsuleToys from './childComps/CapsuleToys.vue'
import CapsuleToyResult from './childComps/CapsuleToyResult.vue'
import CapsuleToyNOResult from './childComps/CapsuleToyNOResult.vue'
import Share from './childComps/Share.vue'
import CapsuleToyNOTicket from './childComps/CapsuleToyNOTicket.vue'
import HeadDetails from './childComps/HeadDetails.vue'
export default {
  data(){
    return {
      iconList: null,
      firstIconList: null
    }
  },
  components: {
    PopUp,
    PopBind,
    PopRule,
    CapsuleToys,
    CapsuleToyResult,
    CapsuleToyNOResult,
    Share,
    CapsuleToyNOTicket,
    HeadDetails,
  },
  computed: {
    ...mapState([ 'currentPop' ]),
  },
  methods: {
    lotteryDate(data){
      this.iconList = data.gotIconList;
      this.firstIconList = data.firstIconList;
    }
  }
}
</script>

<style>

</style>